import { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import TitleSection from "@/components/titleSection";
import aboutFaq from "@/data/faq/about";

const ORANGE = "#e8973a";
const ORANGE_DARK = "#9c5a12";

function FaqSection({ sectionSpace, faqData, subTitle, title, intro }) {
  const data = Array.isArray(faqData) && faqData.length > 0 ? faqData : aboutFaq;
  const headingSub = subTitle ?? "FAQ";
  const headingTitle = title ?? "About Siddhivinayak Group — FAQs";
  const headingIntro =
    intro ??
    "Answers to the most common questions about Siddhivinayak Group's leadership, experience, and operational credibility in Nagpur.";
  const [activeKey, setActiveKey] = useState("0");

  return (
    <div
      className={`ltn__faq-area faq-theme ${sectionSpace}`}
      style={{ backgroundColor: "#f2f6f7" }}
    >
      <Container>
        <Row>
          <Col xs={12} className="mx-auto">
            <TitleSection
              sectionClasses="text-center"
              headingClasses="section-subtitle-2"
              titleSectionData={{
                subTitle: headingSub,
                title: headingTitle,
              }}
            />
          </Col>
        </Row>
        <Row>
          {/* Accordion now spans full width — the "Still have questions?"
              support card was removed so the FAQ list takes the entire
              row. Items render in a 2-column CSS grid on desktop. */}
          <Col xs={12} lg={11} className="mx-auto">
            <Accordion
              activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}
              className="faq-accordion-grid"
            >
              {data.map((item, index) => (
                <Accordion.Item
                  eventKey={String(index)}
                  key={index}
                  className="faq-item"
                >
                  <Accordion.Header as="h3">
                    <span className="faq-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <span className="faq-question">{item.question}</span>
                  </Accordion.Header>
                  <Accordion.Body>{item.answer}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>

      <style jsx global>{`
        .faq-theme .faq-accordion-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
        }
        .faq-theme .faq-accordion-grid .faq-item {
          margin-bottom: 0;
          align-self: start;
        }
        @media (min-width: 768px) {
          .faq-theme .faq-accordion-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
        .faq-theme .faq-item {
          background: #ffffff;
          border: none;
          border-radius: 10px;
          overflow: hidden;
          margin-bottom: 16px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
          transition: box-shadow 0.25s ease;
        }
        .faq-theme .faq-item:last-child {
          margin-bottom: 0;
        }
        .faq-theme .faq-item .accordion-button {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 22px 25px;
          font-family: inherit;
          background: #fff;
        }
        .faq-theme .faq-item .accordion-button:focus {
          box-shadow: none;
          border-color: transparent;
        }
        .faq-theme .faq-item .accordion-button::after {
          filter: invert(56%) sepia(78%) saturate(430%) hue-rotate(1deg)
            brightness(96%) contrast(93%);
        }
        .faq-theme .faq-item .accordion-button:not(.collapsed) {
          background: #fff;
          box-shadow: none;
        }
        .faq-theme .faq-item .accordion-button:not(.collapsed) .faq-question {
          color: ${ORANGE_DARK};
        }
        .faq-theme .faq-item .accordion-button:not(.collapsed) .faq-number {
          background: ${ORANGE_DARK};
          color: #fff;
        }
        .faq-theme .faq-number {
          min-width: 34px;
          height: 34px;
          border-radius: 50%;
          background: #f7f4ef;
          color: ${ORANGE_DARK};
          font-size: 13px;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          transition: all 0.25s ease;
        }
        .faq-theme .faq-question {
          font-weight: 600;
          font-size: 16px;
          color: #1a1a1a;
          transition: color 0.25s ease;
        }
        .faq-theme .accordion-body {
          padding: 0 25px 25px 75px;
          color: #525a64;
          line-height: 1.7;
        }
      `}</style>
    </div>
  );
}

export default FaqSection;